export const returnJobCardText = {
	runPrefix: 'Run:',
	jobPrefix: 'Job:',
	plannedDeparture: 'Planned departure:',
	plannedArrival: 'Planned arrival:',
	mileage: 'Mileage',
	duration: 'Duration',
	assignee: 'Assignee',
	selectButton: 'Select',
};
